<span class="chip">
  <i *ngIf="icon" [class]="icon" class="chip-icon"></i>
  <span class="chip-label">{{ label }}</span>
  <span *ngIf="value" class="chip-sep">·</span>
  <span *ngIf="value" class="chip-value">{{ value }}</span>
</span>
